import { render, staticRenderFns } from "./WastenotificationsFormHeader.vue?vue&type=template&id=1c1ab416"
import script from "./WastenotificationsFormHeader.vue?vue&type=script&lang=js"
export * from "./WastenotificationsFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports